var _path, _path2, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 332,
    viewBox: "0 0 266 332",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.51435e-06 90.6296V295.63C-0.00262157 300.395 0.933449 305.114 2.75489 309.517C4.57633 313.921 7.24737 317.922 10.6155 321.293C13.9836 324.664 17.9829 327.338 22.3848 329.163C26.7866 330.988 31.5048 331.928 36.27 331.93H228.79C238.417 331.93 247.65 328.105 254.458 321.298C261.266 314.49 265.09 305.257 265.09 295.63V36.9396C265.09 27.3122 261.266 18.0792 254.458 11.2716C247.65 4.46404 238.417 0.639648 228.79 0.639648H90.01L18.8401 71.7896L5.51435e-06 90.6296Z",
    fill: "#F7F7FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.6296L18.8401 71.7896L90.01 0.639648H228.79C233.557 0.639648 238.277 1.57846 242.681 3.40271C247.086 5.22696 251.087 7.90084 254.458 11.2716C257.829 14.6424 260.503 18.6441 262.327 23.0482C264.151 27.4523 265.09 32.1726 265.09 36.9396V121.3H0V90.6296Z",
    fill: "#DB679F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.6301L44.4299 100.44C53.8584 102.387 63.6741 100.508 71.7175 95.2178C79.761 89.9274 85.3733 81.6585 87.3201 72.2301L89.1799 62.04C88.5906 64.8475 87.6568 67.5714 86.3999 70.15C83.4288 76.2886 78.7883 81.4658 73.01 85.088C67.2318 88.7103 60.5497 90.6311 53.73 90.6301H0Z",
    fill: "#D7D7D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 90.6299H53.73C60.5497 90.6308 67.2318 88.71 73.01 85.0878C78.7883 81.4655 83.4288 76.2883 86.3999 70.1498C88.7703 65.2089 90.004 59.7999 90.01 54.3198V0.629883L18.8401 71.7898L0 90.6299Z",
    fill: "#EFEFEF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1216 179.22H56.3516V200.99H78.1216V179.22Z",
    fill: "#DB679F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2578 202.1H55.2578V178.1H79.2578V202.1ZM57.4878 199.87H77.0378V180.33H57.4578L57.4878 199.87Z",
    fill: "#DB679F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.887 200.98H78.1172V222.75H99.887V200.98Z",
    fill: "#DB679F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101 223.87H77V199.87H101V223.87ZM79.23 221.64H98.78V202.1H79.26L79.23 221.64Z",
    fill: "#DB679F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M121.661 179.22H99.8906V200.99H121.661V179.22Z",
    fill: "#DB679F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M122.77 202.1H98.7695V178.1H122.77V202.1ZM101 199.87H120.55V180.33H101V199.87Z",
    fill: "#DB679F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M143.43 200.98H121.66V222.75H143.43V200.98Z",
    fill: "#DB679F"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M144.539 223.87H120.539V199.87H144.539V223.87ZM122.769 221.64H142.309V202.1H122.769V221.64Z",
    fill: "#DB679F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M165.2 179.22H143.43V200.99H165.2V179.22Z",
    fill: "#DB679F"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M166.312 202.1H142.312V178.1H166.312V202.1ZM144.542 199.87H164.083V180.33H144.542V199.87Z",
    fill: "#DB679F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.969 200.98H165.199V222.75H186.969V200.98Z",
    fill: "#DB679F"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.078 223.87H164.078V199.87H188.078V223.87ZM166.308 221.64H185.848V202.1H166.308V221.64Z",
    fill: "#DB679F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1216 222.75H56.3516V244.52H78.1216V222.75Z",
    fill: "#DB679F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2578 245.64H55.2578V221.64H79.2578V245.64ZM57.4878 243.41H77.0378V223.87H57.4578L57.4878 243.41Z",
    fill: "#DB679F"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M99.887 244.52H78.1172V266.29H99.887V244.52Z",
    fill: "#DB679F"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M101 267.41H77V243.41H101V267.41ZM79.26 265.18H98.8101V245.64H79.26V265.18Z",
    fill: "#DB679F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M121.661 222.75H99.8906V244.52H121.661V222.75Z",
    fill: "#DB679F"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M122.77 245.64H98.7695V221.64H122.77V245.64ZM101 243.41H120.55V223.87H101V243.41Z",
    fill: "#DB679F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M143.43 244.52H121.66V266.29H143.43V244.52Z",
    fill: "#DB679F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M144.539 267.41H120.539V243.41H144.539V267.41ZM122.769 265.18H142.309V245.64H122.769V265.18Z",
    fill: "#DB679F"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M165.2 222.75H143.43V244.52H165.2V222.75Z",
    fill: "#DB679F"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M166.312 245.64H142.312V221.64H166.312V245.64ZM144.542 243.41H164.083V223.87H144.542V243.41Z",
    fill: "#DB679F"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M186.969 244.52H165.199V266.29H186.969V244.52Z",
    fill: "#DB679F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M188.078 267.41H164.078V243.41H188.078V267.41ZM166.308 265.18H185.848V245.64H166.308V265.18Z",
    fill: "#DB679F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1216 266.29H56.3516V288.06H78.1216V266.29Z",
    fill: "#DB679F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2578 289.18H55.2578V265.18H79.2578V289.18ZM57.4878 286.95H77.0378V267.41H57.4578L57.4878 286.95Z",
    fill: "#DB679F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M121.661 266.29H99.8906V288.06H121.661V266.29Z",
    fill: "#DB679F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.77 289.18H98.7695V265.18H122.77V289.18ZM101 286.95H120.55V267.41H101V286.95Z",
    fill: "#DB679F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M165.2 266.29H143.43V288.06H165.2V266.29Z",
    fill: "#DB679F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M166.312 289.18H142.312V265.18H166.312V289.18ZM144.542 286.95H164.083V267.41H144.542V286.95Z",
    fill: "#DB679F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M208.739 179.22H186.969V200.99H208.739V179.22Z",
    fill: "#DB679F"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M209.852 202.1H185.852V178.1H209.852V202.1ZM188.082 199.87H207.622V180.33H188.082V199.87Z",
    fill: "#DB679F"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M208.739 222.75H186.969V244.52H208.739V222.75Z",
    fill: "#DB679F"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M209.852 245.64H185.852V221.64H209.852V245.64ZM188.082 243.41H207.622V223.87H188.082V243.41Z",
    fill: "#DB679F"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M208.739 266.29H186.969V288.06H208.739V266.29Z",
    fill: "#DB679F"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M209.852 289.18H185.852V265.18H209.852V289.18ZM188.082 286.95H207.622V267.41H188.082V286.95Z",
    fill: "#DB679F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.383a828174aec6d545ae9df3ef9b3653.svg";
export { ForwardRef as ReactComponent };